function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9981 0H1.00041C0.448572 0 0 0.336415 0 0.750275V2.24973C0 2.66358 0.448572 3 1.00041 3H16.9996C17.5514 3 18 2.66358 18 2.24973V0.750275C17.9985 0.336415 17.55 0 16.9981 0Z",
  fill: "#1A854B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9981 4.5H1.00041C0.448572 4.5 0 4.83642 0 5.25027V6.74973C0 7.16358 0.448572 7.5 1.00041 7.5H16.9996C17.5514 7.5 18 7.16358 18 6.74973V5.25027C17.9985 4.83642 17.55 4.5 16.9981 4.5Z",
  fill: "#1A854B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9981 9H1.00041C0.448572 9 0 9.33642 0 9.75027V11.2497C0 11.6636 0.448572 12 1.00041 12H16.9996C17.5514 12 18 11.6636 18 11.2497V9.75027C17.9985 9.33642 17.55 9 16.9981 9Z",
  fill: "#1A854B"
});

function SvgIcLinesGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinesGreen);
export default __webpack_public_path__ + "static/media/ic_lines_green.e20262c5.svg";
export { ForwardRef as ReactComponent };